/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CrmProjectNoteData } from './CrmProjectNoteData';
import {
    CrmProjectNoteDataFromJSON,
    CrmProjectNoteDataFromJSONTyped,
    CrmProjectNoteDataToJSON,
    CrmProjectNoteDataToJSONTyped,
} from './CrmProjectNoteData';
import type { CrmPrimaryContactData } from './CrmPrimaryContactData';
import {
    CrmPrimaryContactDataFromJSON,
    CrmPrimaryContactDataFromJSONTyped,
    CrmPrimaryContactDataToJSON,
    CrmPrimaryContactDataToJSONTyped,
} from './CrmPrimaryContactData';
import type { CrmProjectNotePageData } from './CrmProjectNotePageData';
import {
    CrmProjectNotePageDataFromJSON,
    CrmProjectNotePageDataFromJSONTyped,
    CrmProjectNotePageDataToJSON,
    CrmProjectNotePageDataToJSONTyped,
} from './CrmProjectNotePageData';

/**
 * 
 * @export
 * @interface CrmOpportunityDetailData
 */
export interface CrmOpportunityDetailData {
    /**
     * 
     * @type {string}
     * @memberof CrmOpportunityDetailData
     */
    crmId?: string;
    /**
     * 
     * @type {CrmOpportunityDetailDataRecordTypeEnum}
     * @memberof CrmOpportunityDetailData
     */
    recordType?: CrmOpportunityDetailDataRecordTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CrmOpportunityDetailData
     */
    projectId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmOpportunityDetailData
     */
    name?: string;
    /**
     * 
     * @type {CrmPrimaryContactData}
     * @memberof CrmOpportunityDetailData
     */
    primaryContact?: CrmPrimaryContactData;
    /**
     * 
     * @type {CrmOpportunityDetailDataCrmStatusEnum}
     * @memberof CrmOpportunityDetailData
     */
    crmStatus?: CrmOpportunityDetailDataCrmStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof CrmOpportunityDetailData
     */
    nextContactAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CrmOpportunityDetailData
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CrmOpportunityDetailData
     */
    updatedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CrmOpportunityDetailData
     */
    archivedAt?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CrmOpportunityDetailData
     */
    isArchived?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CrmOpportunityDetailData
     */
    createdByUserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmOpportunityDetailData
     */
    createdByName?: string | null;
    /**
     * 
     * @type {CrmProjectNoteData}
     * @memberof CrmOpportunityDetailData
     */
    latestNote?: CrmProjectNoteData | null;
    /**
     * 
     * @type {CrmProjectNotePageData}
     * @memberof CrmOpportunityDetailData
     */
    notes?: CrmProjectNotePageData;
    /**
     * 
     * @type {CrmOpportunityDetailDataSubscriptionKnowledgeEnum}
     * @memberof CrmOpportunityDetailData
     */
    subscriptionKnowledge?: CrmOpportunityDetailDataSubscriptionKnowledgeEnum;
}


/**
 * @export
 */
export const CrmOpportunityDetailDataRecordTypeEnum = {
    Opportunity: 'opportunity'
} as const;
export type CrmOpportunityDetailDataRecordTypeEnum = typeof CrmOpportunityDetailDataRecordTypeEnum[keyof typeof CrmOpportunityDetailDataRecordTypeEnum];

/**
 * @export
 */
export const CrmOpportunityDetailDataCrmStatusEnum = {
    New: 'new',
    Contacted: 'contacted',
    NeedsHelp: 'needs_help',
    Waiting: 'waiting',
    Active: 'active',
    Churned: 'churned',
    Closed: 'closed'
} as const;
export type CrmOpportunityDetailDataCrmStatusEnum = typeof CrmOpportunityDetailDataCrmStatusEnum[keyof typeof CrmOpportunityDetailDataCrmStatusEnum];

/**
 * @export
 */
export const CrmOpportunityDetailDataSubscriptionKnowledgeEnum = {
    NotApplicable: 'not_applicable'
} as const;
export type CrmOpportunityDetailDataSubscriptionKnowledgeEnum = typeof CrmOpportunityDetailDataSubscriptionKnowledgeEnum[keyof typeof CrmOpportunityDetailDataSubscriptionKnowledgeEnum];


/**
 * Check if a given object implements the CrmOpportunityDetailData interface.
 */
export function instanceOfCrmOpportunityDetailData(value: object): value is CrmOpportunityDetailData {
    return true;
}

export function CrmOpportunityDetailDataFromJSON(json: any): CrmOpportunityDetailData {
    return CrmOpportunityDetailDataFromJSONTyped(json, false);
}

export function CrmOpportunityDetailDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmOpportunityDetailData {
    if (json == null) {
        return json;
    }
    return {
        
        'crmId': json['crmId'] == null ? undefined : json['crmId'],
        'recordType': json['recordType'] == null ? undefined : json['recordType'],
        'projectId': json['projectId'] === undefined ? undefined : json['projectId'] === null ? null : json['projectId'],
        'name': json['name'] == null ? undefined : json['name'],
        'primaryContact': json['primaryContact'] == null ? undefined : CrmPrimaryContactDataFromJSON(json['primaryContact']),
        'crmStatus': json['crmStatus'] == null ? undefined : json['crmStatus'],
        'nextContactAt': json['nextContactAt'] === undefined ? undefined : json['nextContactAt'] === null ? null : (new Date(json['nextContactAt'])),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'archivedAt': json['archivedAt'] === undefined ? undefined : json['archivedAt'] === null ? null : (new Date(json['archivedAt'])),
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
        'createdByUserId': json['createdByUserId'] === undefined ? undefined : json['createdByUserId'] === null ? null : json['createdByUserId'],
        'createdByName': json['createdByName'] === undefined ? undefined : json['createdByName'] === null ? null : json['createdByName'],
        'latestNote': json['latestNote'] === undefined ? undefined : json['latestNote'] === null ? null : CrmProjectNoteDataFromJSON(json['latestNote']),
        'notes': json['notes'] == null ? undefined : CrmProjectNotePageDataFromJSON(json['notes']),
        'subscriptionKnowledge': json['subscriptionKnowledge'] == null ? undefined : json['subscriptionKnowledge'],
    };
}

export function CrmOpportunityDetailDataToJSON(json: any): CrmOpportunityDetailData {
    return CrmOpportunityDetailDataToJSONTyped(json, false);
}

export function CrmOpportunityDetailDataToJSONTyped(value?: CrmOpportunityDetailData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'crmId': value['crmId'],
        'recordType': value['recordType'],
        'projectId': value['projectId'],
        'name': value['name'],
        'primaryContact': CrmPrimaryContactDataToJSON(value['primaryContact']),
        'crmStatus': value['crmStatus'],
        'nextContactAt': value['nextContactAt'] == null ? value['nextContactAt'] : value['nextContactAt'].toISOString(),
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'archivedAt': value['archivedAt'] == null ? value['archivedAt'] : value['archivedAt'].toISOString(),
        'isArchived': value['isArchived'],
        'createdByUserId': value['createdByUserId'],
        'createdByName': value['createdByName'],
        'latestNote': CrmProjectNoteDataToJSON(value['latestNote']),
        'notes': CrmProjectNotePageDataToJSON(value['notes']),
        'subscriptionKnowledge': value['subscriptionKnowledge'],
    };
}

